import React, { useState, useRef, useEffect } from 'react'
import { ButtonHLPure, LabelHLPure, DialogPdfHLPure, ValidationCodePure, CheckBoxHLPure, InstructionsPure } from '../../pures'
import { PlusBlue } from '../../../assets/logos/icons'
import { useMediaQuery } from '@material-ui/core'
import CanvasDraw from '@win11react/react-canvas-draw'
import { getStampTimeAndTimezone } from '../../../utils'
import './signature-base-autograph.css'
import { useCanvasDimensions, useScreenOrientation } from '../../../hooks'

const SignatureBaseAutograph = (props) => {
    let {
        t,
        step,
        selectedStep,
        onHandleNext,
        onHandleBack,
        signatureImg,
        firstName,
        firstLastName,
        secondLastName,
        setIMGSignature,
        nip,
        setNIP,
        validateNip,
        setValidateNIP,
        nipCheck,
        setNIPCheckbox,
        signatureData
    } = props

    const { next, back } = step

    const orientation = useScreenOrientation()
    const pad = useRef(null)

    const mobileResolution = useMediaQuery('(max-width:560px)')

    let yPositionCanvas = {
        y1: 205,
        y2: 235,
        y3: 275
    }

    let heightContainer = 570
    let widthContainer = mobileResolution ? 600 : 718

    const [showModalSignature, setShowModalSignature] = useState(false)
    const [nameUser, setNameUser] = useState('')
    const [lastNameUser, setLastNameUser] = useState('')
    const { width, height, updateDimensions } = useCanvasDimensions()
    const [secondLastNameUser, setSecondLastnameUser] = useState('')
    const isMobile = useMediaQuery('(max-width: 700px), (max-height: 400px)')
    const [disableSubmit, setDisableSubmit] = useState(true)

    /**
    * @param {OrientationType} orientation
    */
    function adjustYCoordinates(orientation) {
        if (!pad.current) return
        let sourceCanvas = document.getElementsByTagName('canvas')
        const gottenCanvas = sourceCanvas[1]

        if (orientation === 'portrait-primary' || orientation === 'portrait-secondary') {
            if (gottenCanvas.height >= 300) yPositionCanvas = {
                y1: gottenCanvas.height - 80,
                y2: gottenCanvas.height - 60,
                y3: gottenCanvas.height - 40
            }
            else yPositionCanvas = {
                y1: gottenCanvas.height - 50,
                y2: gottenCanvas.height - 35,
                y3: gottenCanvas.height - 15
            }
        } else if (orientation === 'landscape-primary' || orientation === 'landscape-secondary')
            yPositionCanvas = {
                y1: gottenCanvas.height - 80,
                y2: gottenCanvas.height - 60,
                y3: gottenCanvas.height - 40
            }
    }

    useEffect(() => {
        if (selectedStep !== 2) return
        setNIP('')
        setValidateNIP('')
    }, [selectedStep])

    useEffect(() => {
        let infodevice = navigator.userAgent
        signatureData.delete('deviceBody')
        signatureData.delete('osBody')
        signatureData.delete('browserBody')
        signatureData.delete('interfaceBody')

        let deviceBody = 'Pc'
        if (infodevice.includes('mac')) deviceBody = 'Mac'
        if (infodevice.includes('windows')) deviceBody = 'Pc'
        if (infodevice.includes('android')) deviceBody = 'Android'
        if (infodevice.includes('iphone')) deviceBody = 'iPhone'
        if (infodevice.includes('ipad')) deviceBody = 'iPad'
        if (infodevice.includes('mobile')) deviceBody = 'Mobile'
        signatureData.append('deviceBody', deviceBody)
        signatureData.append('osBody', getOperatingSystem())
        signatureData.append('browserBody', getBrowser())
        signatureData.append('interfaceBody', 'MiFirma-Web')
        if (signatureImg) urlToBlob(signatureImg, 'signImage')
    }, [])

    useEffect(() => {
        urlToBlob(signatureImg, 'signImage')
    }, [signatureImg])

    useEffect(() => {
        if (!firstName) return
        setNameUser(firstName)
        setLastNameUser(firstLastName)
        setSecondLastnameUser(secondLastName)
    }, [firstName, firstLastName, secondLastName])

    const getOperatingSystem = () => {
        let operatingSystem = 'Not known'
        if (window.navigator.appVersion.indexOf('Win') !== -1) {
            operatingSystem = 'Windows OS'
        }
        if (window.navigator.appVersion.indexOf('Mac') !== -1) {
            operatingSystem = 'MacOS'
        }
        if (window.navigator.appVersion.indexOf('X11') !== -1) {
            operatingSystem = 'UNIX OS'
        }
        if (window.navigator.appVersion.indexOf('Linux') !== -1) {
            operatingSystem = 'Linux OS'
        }
        return operatingSystem
    }

    const getBrowser = () => {
        let currentBrowser = 'Not known'
        if (window.navigator.userAgent.indexOf('Chrome') !== -1) {
            currentBrowser = 'Google Chrome'
        } else if (window.navigator.userAgent.indexOf('Firefox') !== -1) {
            currentBrowser = 'Mozilla Firefox'
        } else if (window.navigator.userAgent.indexOf('MSIE') !== -1) {
            currentBrowser = 'Internet Explorer'
        } else if (window.navigator.userAgent.indexOf('Edge') !== -1) {
            currentBrowser = 'Edge'
        } else if (window.navigator.userAgent.indexOf('Safari') !== -1) {
            currentBrowser = 'Safari'
        } else if (window.navigator.userAgent.indexOf('Opera') !== -1) {
            currentBrowser = 'Opera'
        } else if (window.navigator.userAgent.indexOf('Opera') !== -1) {
            currentBrowser = 'YaBrowser'
        }
        return currentBrowser
    }

    const urlToBlob = async (url, key) =>
        await fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
                const file = new File([blob], key + '.png')
                signatureData.delete(key)
                signatureData.append(key, file)
            })

    const handleShowModalSignature = () => {
        setShowModalSignature(true)
        setTimeout(() => {
            updateDimensions(pad)
        }, 50)
        setTimeout(async () => {
            await setUserDataInCanvas()
        }, 400)
    }

    const setUserDataInCanvas = async () => {
        adjustYCoordinates(orientation)
        const stampTime = await getStampTimeAndTimezone()
        if (stampTime === false) {
            setShowModalSignature(false)
        }

        if ((nameUser.length + `${lastNameUser} ${secondLastName}`.trim().length) > 26) {
            setTextInCanvas(yPositionCanvas.y1, `${nameUser}`)
            setTextInCanvas(yPositionCanvas.y2, `${lastNameUser} ${secondLastNameUser}`)
        } else {
            setTextInCanvas(yPositionCanvas.y2, `${nameUser} ${lastNameUser} ${secondLastNameUser}`)
        }
    }

    const setTextInCanvas = (y, text) => {
        try {
            let sourceCanvas = document.getElementsByTagName('canvas')
            const gottenCanvas = sourceCanvas[1]
            let ctx = gottenCanvas.getContext('2d')

            ctx.font = 'bold 23px Arial'
            if (isMobile && (orientation === 'portrait-primary' || orientation === 'portrait-secondary')) ctx.font = 'bold 13px Arial'
            else if (isMobile && (orientation === 'landscape-primary' || orientation === 'landscape-secondary')) ctx.font = 'bold 19px Arial'

            ctx.textAlign = 'center'
            ctx.fillText(text, gottenCanvas.width / 2, y)
        } catch (error) {
        }
    }

    const clearSignature = (e) => {
        e.preventDefault()
        pad.current.clear()
        setUserDataInCanvas()
    }

    const saveImage = () => {
        let sourceCanvas = document.getElementsByTagName('canvas')[1]
        let destinationCanvas = document.createElement('canvas')
        destinationCanvas.height = sourceCanvas.height
        destinationCanvas.width = sourceCanvas.width
        let destinationContext = destinationCanvas.getContext('2d')
        destinationContext.drawImage(sourceCanvas, 0, 0)
        destinationContext.globalCompositeOperation = 'destination-over'
        destinationContext.fillStyle = '#4484a500'
        destinationContext.fillRect(
            0,
            0,
            destinationCanvas.width,
            destinationCanvas.height
        )
        let image = destinationCanvas.toDataURL('image/png')
        return image
    }

    const saveSignature = () => {
        let signatureConvert = saveImage()
        setIMGSignature(signatureConvert)
        setShowModalSignature(false)
    }

    return (
        <div className='signatureBaseAutograph-container'>
            <div className='signatureBaseAutograph-body'>
                <div className='signatureBaseAutograph-text-container'>
                    <div className='signatureBaseAutograph-text'>
                        <InstructionsPure instructions={[t('signatureBaseAutograph.text')]} />
                    </div>
                </div>
                <div className='signatureBaseUploadINE-signature-nip'>
                    <div className='signatureBaseUploadINE-signature'>
                        <div className={'rec-signature-base'} onClick={() => handleShowModalSignature()}>
                            <img src={PlusBlue} width='40' />
                            <img className={(signatureImg) ? 'signatureBaseUploadINE-image-ine ' : 'signatureBaseUploadINE-image-default'} src={signatureImg} />

                            {!signatureImg && (
                                <div className='signatureBaseUploadINE-name'>
                                    <p className='signatureBaseUploadINE-firstName'>{nameUser}</p>
                                    <p className='signatureBaseUploadINE-lastName'>{`${lastNameUser} ${secondLastNameUser}`}</p>
                                </div>
                            )
                            }
                        </div>
                        <p className='signatureCredetialForm-p-sub'>
                            {t('signatureBaseAutograph.upload.sign')}
                        </p>
                    </div>
                    <div className='signatureBaseUploadINE-nips'>
                        <div>
                            <ValidationCodePure
                                data={nip}
                                setData={setNIP}
                                validationLength={4}
                                title={t('signatureBaseAutograph.nip')}
                                hide={true}
                                autoFocusNIP={true}
                            />
                        </div>
                        <div>
                            <ValidationCodePure
                                data={validateNip}
                                setData={setValidateNIP}
                                validationLength={4}
                                title={t('signatureBaseAutograph.repeat.nip')}
                                hide={true}
                            />
                        </div>
                    </div>
                </div>
                <div className='signatureBaseUploadINE-container-check-box'>
                    <div className='signatureBaseUploadINE-check-box'>
                        <CheckBoxHLPure
                            valueCheckBox={true}
                            checkedState={nipCheck}
                            labelCheckBox={t('signatureBaseAutograph.check.box')}
                            onChangeHandler={setNIPCheckbox}
                        />
                        <div className='signatureBaseUploadINE-check-label'>
                            <LabelHLPure
                                text={t('signatureBaseAutograph.label.check.box')}
                                fontSize={'14px'}
                                showTooltip={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='signatureBaseAutograph-container-btns'>
                <div className='signatureBaseAutograph-btn-secundary'>
                    <ButtonHLPure
                        nameBtn={back}
                        primary={false}
                        onClickBtn={onHandleBack}
                    />
                </div>
                <ButtonHLPure
                    nameBtn={next}
                    primary={true}
                    onClickBtn={onHandleNext}
                />
            </div>
            {showModalSignature && (
                <DialogPdfHLPure
                    disableSubmit={disableSubmit}
                    title={t('signatureBaseAutograph.title.modal')}
                    description={t('signatureBaseAutograph.description.modal')}
                    saveBtn={t('signatureBaseAutograph.btn.capture')}
                    canelBtn={t('dialogDeleteSignature.buttonCancel')}
                    width={widthContainer}
                    height={heightContainer}
                    handleSubmitProfile={() => {
                        saveSignature()
                        setDisableSubmit(true)
                    }}
                    cancel={() => {
                        setDisableSubmit(true)
                        setShowModalSignature(false)
                    }}
                    showExtraBtn={true}
                    extrabtnlabel={t('signatureBaseAutograph.btn.clean')}
                    handleExtraBtn={(e) => {
                        clearSignature(e)
                        setDisableSubmit(true)
                    }}
                    classNameDescription={'signatureBaseAutograph-description'}
                >
                    <div className={'signatureCredretialForm-canvas-draw'}>
                        <CanvasDraw
                            ref={pad}
                            loadTimeOffset={0}
                            lazyRadius={2}
                            brushRadius={2}
                            brushColor={'#000'}
                            catenaryColor={'#0a0302'}
                            gridColor={'rgba(150,150,150,0.17)'}
                            hideGrid={true}
                            canvasWidth={width}
                            canvasHeight={height}
                            disabled={false}
                            immediateLoading={true}
                            hideInterface={false}
                            onChange={() => { setDisableSubmit(false) }}
                        />
                    </div>
                </DialogPdfHLPure>
            )}
        </div>
    )
}

export { SignatureBaseAutograph as default }